import { render, staticRenderFns } from "./dataPlate.vue?vue&type=template&id=fe12871c&scoped=true&"
import script from "./dataPlate.vue?vue&type=script&lang=js&"
export * from "./dataPlate.vue?vue&type=script&lang=js&"
import style0 from "./dataPlate.vue?vue&type=style&index=0&id=fe12871c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe12871c",
  null
  
)

export default component.exports